<template>
  <div class="flex-area">
    <!-- 营销一区 -->
    <div class="flex-area-item">
      <div class="flex-item" v-for="(item,index) in one" :key='`t_${index}`' :class="{'flex-item-big': !item.iconFlag}" @click="goPage(item)">
        <template v-if="item.hyperType == 30">
          <findGoods :refresh="refresh" :activityId="item.activityId" :configInfo="item"/>
        </template>
        <template v-else-if="item.hyperType == 31">
          <lifeHome :configInfo="item"/>
        </template>
        <template v-else>
            <h4><span :style="{'color': item.titleColor}">{{item.title}}</span><a v-if="!item.iconFlag" href="javascript:;" :style="{'border': `1px solid ${item.sdColor}`, 'color': item.sdColor}">{{item.subTitle}} <van-icon name="arrow" size=".22rem" :color="item.sdColor"/></a></h4>
          <p :style="{'color': item.sdColor}">{{item.description}}</p>
          <div class="flex-img">
            <img :src="item.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt="">
          </div>
        </template>
      </div>
    </div>
    <!-- 营销二区 -->
    <div class="flex-area-item">
      <div class="flex-item" v-for="(item,index) in two" :key='`k_${index}`' :class="{'flex-item-big': !item.iconFlag}" @click="goPage(item)">
        <div class="flex-img">
          <img :src="item.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt="">
        </div>
      </div>
    </div>
    <!-- 营销三区 -->
    <div class="flex-area-item">
      <div class="flex-item" v-for="(item,index) in three" :key='`l_${index}`' :class="{'flex-item-big': !item.iconFlag}" @click="goPage(item)">
        <template v-if="item.hyperType == 30">
          <findGoods :refresh="refresh" :activityId="item.activityId" :configInfo="item"/>
        </template>
        <template v-else-if="item.hyperType == 31">
          <lifeHome :configInfo="item"/>
        </template>
        <template v-else>
            <h4><span :style="{'color': item.titleColor}">{{item.title}}</span><a v-if="!item.iconFlag" href="javascript:;" :style="{'border': `1px solid ${item.sdColor}`, 'color': item.sdColor}">{{item.subTitle}} <van-icon name="arrow" size=".22rem" :color="item.sdColor"/></a></h4>
          <p :style="{'color': item.sdColor}">{{item.description}}</p>
          <div class="flex-img">
            <img :src="item.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt="">
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import findGoods from './findgoods'
import lifeHome from './lifeHome'

export default {
  name: 'flexarea',
  components: {
    lifeHome,
    findGoods
  },
  props: {
    refresh: {
      type: Number,
      default: 1,
    },
    one: {
      type: Array,
      default: () => []
    },
    two: {
      type: Array,
      default: () => []
    },
    three: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    goPage(item) {
      // 埋点
      this.$util.gioTrackWithVariable('MB15598', {
        text: item.title || 'null'
      })
      this.$store.dispatch('goPageByType', {
        type: Number(item.hyperType),
        params: item.hyperParam,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-area{
  padding-bottom: .24rem;
}
.flex-area-item{
  width: 6.6rem;
  padding: 0 .2rem;
  padding-right: 0;
  display: flex;
  overflow: hidden;
}
.flex-item{
  width: 1.54rem;
  padding-top: .24rem;
  margin-right: .11rem;
  vertical-align: top;
  h4{
    display: flex;
    justify-content: space-between;
    height: .34rem;
    margin-bottom: .16rem;
    line-height: .34rem;
    color: #333;
    font-weight: 600;
    span{
      font-weight: 600;
      font-size: .3rem;
      line-height: .3rem;
      padding-top: .04rem;
      @include text-overflow(1)
    }
    a{
      display: none;
    }
  }
  p{
    margin-bottom: .16rem;
    font-size: .24rem;
    height: .24rem;
    line-height: .26rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // @include text-overflow(1);
    padding-top: .02rem;
  }
  .flex-img{
    width: 1.54rem;
    height: 1.54rem;
    overflow: hidden;
    border-radius: .16rem;
    img{
      width: 1.54rem;
      height: 1.54rem;
    }
  }
}

.flex-item-big{
  width: 3.14rem;
  margin-right: .16rem;
  h4{
    span{
      max-width: 2rem;
    }
    a{
      max-width: 1.4rem;
      margin-left: .1rem;
      display: inline-flex;
      align-items: center;
      padding: .02rem .14rem;
      font-size: .22rem;
      border-radius: .2rem;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .flex-img{
    width: 3.14rem;
    height: 1.72rem;
    img{
      width: 3.22rem;
      height: 1.72rem;
    }
  }
}

</style>
